import { ReactNode } from 'react';
import { UserState } from '@hooks/useUser';
import { PageLayout } from '@layouts';
import { NotFoundFallback } from '@components';
import { checkUserAuthorized } from '../utils/authorization';

interface ProtectedRouteProps {
  user: UserState;
  permittedRoles: string[];
  children: ReactNode;
  featureFlagEnabled?: boolean;
  layoutGutterTop?: boolean;
  layoutGutterHorizontal?: boolean;
  layoutGutterBottom?: boolean;
}

const ProtectedRoute = ({
  user,
  permittedRoles,
  children,
  featureFlagEnabled = true, // default to true so the prop only has to be passed for flagged routes
  layoutGutterTop = true,
  layoutGutterHorizontal = true,
  layoutGutterBottom = true,
}: ProtectedRouteProps) => {
  const permitted = checkUserAuthorized(user.profile, permittedRoles);

  return permitted && featureFlagEnabled
    ? (
      <PageLayout
        gutterTop={layoutGutterTop}
        gutterHorizontal={layoutGutterHorizontal}
        gutterBottom={layoutGutterBottom}
      >
        {children}
      </PageLayout>
    )
    : <NotFoundFallback />;
}

export default ProtectedRoute;